// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[type=file]{display:none}.content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.actions,.preview-area p:last-of-type{margin-top:1rem}.preview{width:100%;height:209.25px;overflow:hidden}.cropped-image img{max-width:100%}.cropper-bg{background-repeat:repeat}.cropper-min-height{min-height:400px}", ""]);
// Exports
module.exports = exports;
